class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    this.toggleAddButton(true, '', false);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return;  // Stop execution if false
    }

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSaleBadge();
    }
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest('.main-product');
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        productElement.innerHTML = html.querySelector('.main-product').innerHTML;
        const keepParams = new URLSearchParams(window.location.search);
        keepParams.delete('variant');
        const query = keepParams.toString();
        window.history.replaceState({ }, '', `${newProductUrl}${query ? '?' + query : ''}`);
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    
    // Add Season option if product has 3 options but Season is hidden from UI
    // Some products have Season option that's skipped in the UI but needed for variant matching
    const variantData = this.getVariantData();
    let expectedOptionsCount = 2; // Default to 2 options
    
    if (variantData && variantData.length > 0) {
      const firstVariant = variantData[0];
      // Count non-null option values
      const nonNullOptions = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(opt => opt !== null && opt !== undefined && opt !== '');
      expectedOptionsCount = nonNullOptions.length;
    
    }
    
    // Only add Season if product expects 3 options and we have fewer than 3
    if (expectedOptionsCount === 3 && this.options.length >= 1 && this.options.length < 3) {
      // Look for Season option in variant data
      if (variantData && variantData.length > 0) {
        const firstVariant = variantData[0];
        let seasonValue = '1001'; // Default season value
        
        // Try to find the season value from the variant data
        if (firstVariant.option2 && firstVariant.option2 !== firstVariant.option1 && firstVariant.option2 !== firstVariant.option3) {
          seasonValue = firstVariant.option2;
        }
        
        // Insert Season as option2 (index 1) - correct order: [Color, Season, Size]
        if (this.options.length === 1) {
          // Only Color found, add Season as second option
          this.options.push(seasonValue);
        
        } else if (this.options.length === 2) {
          // Color and Size found, insert Season between them
          const sizeOption = this.options.pop(); // Remove size (last option)
          this.options.push(seasonValue); // Add season as option2
          this.options.push(sizeOption); // Add size back as option3
         
        }
      }
    }
    
    
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);

    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }

    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
    if (isDesktop && isGrid) {
      document.getElementById(`item-${this.currentVariant.featured_media.id}`)?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    const query = params.toString();
    window.history.replaceState({ }, '', `${this.dataset.url}${query ? '?' + query : ''}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSaleBadge() {
    if (!this.currentVariant) return;

    const saleBadge = document.getElementById('saleBadge');
    if (!saleBadge) return;

    const comparePrice = this.currentVariant.compare_at_price;
    const salePrice = this.currentVariant.price;

    if (comparePrice && comparePrice > salePrice) {
      const badgeType = saleBadge.dataset.saleBadgeType || 'default';
      let badgeText = '';

      if (badgeType === 'savings') {
        // Calculate savings amount
        const savingsAmount = comparePrice - salePrice;
        const formattedSavings = Woolman.Utils.formatMoney(savingsAmount);
        badgeText = window.saleBadgeStrings.savings.replace('[amount]', formattedSavings);
      } else if (badgeType === 'percentage') {
        // Calculate discount percentage
        const discountPercentage = Math.floor(((comparePrice - salePrice) / comparePrice) * 100);
        badgeText = window.saleBadgeStrings.percentage.replace('[percentage]', discountPercentage);
      } else {
        // Default badge type
        badgeText = window.saleBadgeStrings?.default;
      }

      saleBadge.textContent = badgeText;
      saleBadge.classList.remove('hide');
    } else {
      // Hide badge if no discount
      saleBadge.classList.add('hide');
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    
    // Check if this product has a hidden Season option
    const variantData = this.getVariantData();
    let hasHiddenSeason = false;
    if (variantData && variantData.length > 0) {
      const firstVariant = variantData[0];
      const nonNullOptions = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(opt => opt !== null && opt !== undefined && opt !== '');
      hasHiddenSeason = nonNullOptions.length === 3 && inputWrappers.length === 2; // 3 variant options but only 2 UI inputs
     
    }
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      
      let availableOptionInputsValue;
      if (hasHiddenSeason) {
        // For products with hidden Season: Color (option1), Season (option2 - hidden), Size (option3)
        // UI index 1 corresponds to variant option3 (Size)
        const variantOptionIndex = index + 2; // UI index 1 -> variant option3
       
        availableOptionInputsValue = selectedOptionOneVariants.filter(variant => {
          return variant.available && variant.option1 === previousOptionSelected;
        }).map(variantOption => variantOption[`option${variantOptionIndex}`]);
      } else {
        // Normal products: use original logic
        const variantOptionIndex = index + 1;
        availableOptionInputsValue = selectedOptionOneVariants.filter(variant => {
          return variant.available && variant[`option${index}`] === previousOptionSelected;
        }).map(variantOption => variantOption[`option${variantOptionIndex}`]);
      }
      
     
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock :
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (addButton_BuyBar && addButtonText_BuyBar) {
        if (disable) {
          addButton_BuyBar.setAttribute("disabled", "disabled");
          if (text) addButtonText_BuyBar.textContent = text;
        } else {
          addButton_BuyBar.removeAttribute("disabled");
          if (this.dataset.isPreorder == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
          } else {
            addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
          }
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (button_BuyBar) {
      const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = button_BuyBar.querySelector(
        '[name="add"] > span'
      );
      const price_BuyBar = document.getElementById(
        `price-${this.dataset.section}-product-buy-bar`
      );
      if (addButton_BuyBar && addButtonText_BuyBar) {
        addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
      }
      if (price_BuyBar) price_BuyBar.classList.add("hidden");
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
   
    listOfOptions.forEach(input => {
      const inputValue = input.getAttribute('value');
      if (listOfAvailableOptions.includes(inputValue)) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    // Add Season option if product has 3 options but Season is hidden from UI
    // Some products have Season option that's skipped in the UI but needed for variant matching
    const variantData = this.getVariantData();
    let expectedOptionsCount = 2; // Default to 2 options
    
    if (variantData && variantData.length > 0) {
      const firstVariant = variantData[0];
      // Count non-null option values
      const nonNullOptions = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(opt => opt !== null && opt !== undefined && opt !== '');
      expectedOptionsCount = nonNullOptions.length;
     
    }
    
    // Only add Season if product expects 3 options and we have fewer than 3
    if (expectedOptionsCount === 3 && this.options.length >= 1 && this.options.length < 3) {
      // Look for Season option in variant data
      if (variantData && variantData.length > 0) {
        const firstVariant = variantData[0];
        let seasonValue = '1001'; // Default season value
        
        // Try to find the season value from the variant data
        if (firstVariant.option2 && firstVariant.option2 !== firstVariant.option1 && firstVariant.option2 !== firstVariant.option3) {
          seasonValue = firstVariant.option2;
        }
        
        // Insert Season as option2 (index 1) - correct order: [Color, Season, Size]
        if (this.options.length === 1) {
          // Only Color found, add Season as second option
          this.options.push(seasonValue);
        } else if (this.options.length === 2) {
          // Color and Size found, insert Season between them
          const sizeOption = this.options.pop(); // Remove size (last option)
          this.options.push(seasonValue); // Add season as option2
          this.options.push(sizeOption); // Add size back as option3
        
        }
      }
    }
    
    

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);